<template>
    <!-- <div>
        {{all_questions.questions_pot}}
    </div> -->
  <div class="temp-wrap">
    <div class="main-title">
      <h1 v-html="all_questions.questions_pot.title"></h1>
      
    </div>
    <div class="bottom-list-wrap" >
      <ul class="custom-scroller">


        <li class="ways-li">
          <div class="ways-title">{{all_questions.questions_pot.use_ways.title}}</div>
          <div class="all-ways">
            <div class="way" v-for="(way, id) in all_questions.questions_pot.use_ways.ways">
              <div class="num">{{id+1}}.&nbsp</div>
              <div class="text">{{way}}</div>
            </div>
          </div>
        </li>

        <li class="ways-li">
          <div class="ways-title">{{all_questions.questions_pot.keep_ways.title}}</div>
          <div class="all-ways">
            <div class="way" v-for="(way, id) in all_questions.questions_pot.keep_ways.ways">
              <div class="num">{{id+1}}.&nbsp</div>
              <div class="text">{{way}}</div>
            </div>
          </div>
        </li>


        <li class="qa-li" v-for="q in all_questions.questions_pot.questions">
          
          <div class="qa-div q">
            <div class="char">Q :</div>
            <div class="text">{{q.q}}</div>
          </div>
          <div class="qa-div">
            <div class="char">A :</div>
            <div class="text">{{q.a}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import ct_scroll from './function.js'
export default {
    props: ["all_questions"],
    mounted(){
        ct_scroll();
    }

}
</script>


// WEBPACK FOOTER //
// src/Qna/pot.vue